import { faker } from '@faker-js/faker'

import { PaymentConfig } from '../../contracts/payment'
import { asBuilder } from '../asBuilder'

export const getGroupedServiceOffer = asBuilder((): PaymentConfig => {
  return {
    hospitalId: faker.number.int(),
    offline: {
      pointRedemptionEnabled: faker.datatype.boolean(),
    },
    online: {
      enabled: faker.datatype.boolean(),
      history: [],
    },
    accountingSettings: {
      accountNumber: faker.string.uuid(),
      accountBankName: faker.string.uuid(),
      accountHolderName: faker.string.uuid(),
      passbookCopyFile: faker.string.uuid(),
    },
  }
})
